// @flow

import * as React from "react";
import { withRouter } from "react-router-dom";
import cx from "classnames";

import DownloadPdf from "../DownloadPdf";

import styles from "./InquiryPage.scss";
import NavTabs from "../Navbar/PortalNavbar/NavTabs/NavTabs";
import Preloader from "../Preloader";
import Footer from "../Footer";

type InquiryPageProps = {
  children: React.Node,
  match: {
    params: {
      id: number
    }
  },
  isLoadingData: boolean,
  backPath: string,
  tabs: number => any,
  generatePDFtemplate?: () => void,
  downloadPdf?: () => void,
  pdfData: any
};

const InquiryPage = ({
  isLoadingData,
  match,
  children,
  backPath,
  tabs,
  generatePDFtemplate,
  pdfData,
  downloadPdf
}: InquiryPageProps) => {
  const { id } = match.params;

  return (
    <div className={styles.inquiryPage}>
      {isLoadingData && <div className={styles.loadingOverlay} />}
      <div className={styles.navTabs}>
        {!isLoadingData && <NavTabs tabs={tabs(id)} backPath={backPath} />}
      </div>
      <div className={styles.wrapper}>
        <div className={styles.pageContent}>
          <div>
            {(generatePDFtemplate || downloadPdf) && (
              <DownloadPdf
                pdfData={pdfData}
                generatePDFtemplate={generatePDFtemplate}
                downloadPdf={downloadPdf}
              />
            )}
          </div>
          <div className={cx(styles.content)}>
            {isLoadingData && (
              <div className={styles.loader}>
                <Preloader />
              </div>
            )}
            {children}
          </div>
        </div>
        <Footer type="portal" />
      </div>
    </div>
  );
};

export default withRouter(InquiryPage);
